import React, { Component } from 'react';

class getTeclado extends Component {
  render (){
    return (
      <div>
        <input className="css-cantidad" type="text" value={this.props.cantidad} placeholder="CANT"  onChange={(event)=>this.props.inputChangedHandler(event)} />
        <input className="css-cantidad" type="text" id="observacion" name="observacion"  value={this.props.observacion} placeholder="OBSERVACION"  onChange={(event)=>this.props.inputChangedHandlerO(event)} />
        <br/>
        <div className="grid-container_teclado" >
          <div className="div_uno"><button className="btn_teclado" onClick={ () => this.props.setTeclado(1)} >1</button></div>
          <div className="div_dos"><button className="btn_teclado" onClick={ () => this.props.setTeclado(2)} >2</button></div>
          <div className="div_tres"><button className="btn_teclado" onClick={ () => this.props.setTeclado(3)} >3</button></div>
          <div className="div_cuatro"><button className="btn_teclado" onClick={ () => this.props.setTeclado(4)} >4</button></div>
          <div className="div_cinco"><button className="btn_teclado" onClick={ () => this.props.setTeclado(5)} >5</button></div>
          <div className="div_seis"><button className="btn_teclado" onClick={ () => this.props.setTeclado(6)} >6</button></div>
          <div className="div_siete"><button className="btn_teclado" onClick={ () => this.props.setTeclado(7)} >7</button></div>
          <div className="div_ocho"><button className="btn_teclado" onClick={ () => this.props.setTeclado(8)} >8</button></div>
          <div className="div_nueve"><button className="btn_teclado" onClick={ () => this.props.setTeclado(9)} >9</button></div>
          <div className="div_cero"><button className="btn_teclado" onClick={ () => this.props.setTeclado(0)} >0</button></div>
          <div className="div_delete"><button className="btn_teclado" onClick={ () => this.props.setTeclado("DEL")} >DEL</button></div>
          <div className="div_punto"><button className="btn_teclado" onClick={ () => this.props.setTeclado(".")} >.</button></div>
          <div className="div_enter"></div>

        </div>
      </div>
    )
  }
}
/*<div className="div_guardar"><button className="btn_teclado_opcion_2" onClick={ () => this.props.getActualizarCabecera()}>GUARDAR</button></div>*/
export default getTeclado;
